import { Navigate } from 'react-router';
import { enableAIConfigWaitlistPage, enableStickyProjectNavigationMode } from '@gonfalon/dogfood-flags/dogfood-flags';

import { useProjectNavModePreference } from './ProjectNavModePreferenceProvider';

/**
 * Index route for `/projects/:projectKey`, and the client-side half of
 * `projectRootRedirect` in `internal/site/redirect.go`. The server handles cold
 * loads, this handles in-app navigation, and both must pick the same section.
 *
 * Reads the mode as the server resolved it, not the switcher-gated mode from
 * `useProjectNavMode`. That one also hides agent mode whenever the switcher is
 * off screen, which is the right question for a sidebar and the wrong one for a
 * redirect: gating on it here sent a cold load to AI Configs and an in-app
 * navigation to the flag list.
 */
export function ProjectIndexRedirect() {
  const { preferredNavMode } = useProjectNavModePreference();
  // `ai-config-waitlist` is the same term the server resolves with, and asking it
  // here rather than trusting the mode to arrive already resolved. The write is
  // optimistic, so for one round trip this holds the member's raw choice, which
  // can name a section the server will not send them to.
  const landsInAgentMode =
    enableStickyProjectNavigationMode() && preferredNavMode === 'agent' && enableAIConfigWaitlistPage();

  return <Navigate to={landsInAgentMode ? 'ai-configs' : 'flags'} replace />;
}
